import React from 'react';
import PropTypes from 'prop-types';
import Marker from './Marker';

export default class SVGMarker extends React.Component {
  render() {
    const svg = new DOMParser().parseFromString(this.props.icon, 'image/svg+xml');
    const colorize = svg.querySelector('.colorize');
    if (colorize) {
      colorize.style.fill = this.props.color;
    }

    const size = this.props.size instanceof Array ? this.props.size : [this.props.size, this.props.size];

    const icon = {
      html: svg.documentElement.outerHTML,
      size,
      className: this.props.cssClass
    };

    return (
      <Marker position={this.props.position} icon={icon} zIndexOffset={800} type={this.props.markerType}>
        {this.props.title}
      </Marker>
    );
  }
}

SVGMarker.defaultProps = {
  size: 24,
  cssClass: 'marker'
};

SVGMarker.propTypes = {
  position: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.shape({ lat: PropTypes.number, lng: PropTypes.number })
  ]).isRequired,
  icon: PropTypes.any.isRequired,
  color: PropTypes.string.isRequired,
  title: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),
  cssClass: PropTypes.string,
  markerType: PropTypes.string.isRequired
};
